import { GET_ORGANIZATION_TEMPLATES_FILTERS_METADATA } from '../../contracts';

import { useQuery } from '@tanstack/react-query';
import { type TemplateSearchFilterMetadataResponse } from '../../contracts';
import { getOrganizationTemplatesMetadata } from '../api/templates';

export function useQueryOrganizationTemplatesFiltersMetadata<
  T = TemplateSearchFilterMetadataResponse,
>(
  organizationId: string,
  select?: (data: TemplateSearchFilterMetadataResponse) => T,
  /**
   * The app's gate, composed and passed in (cohort-C). Pre-move this hook read
   * `state.auth.token` from Rematch AND `useQueryUser().kinde_user_id`; both are
   * app reads, and injecting either would relocate the coupling rather than
   * remove it. The delegate composes them at the same render-time position.
   */
  isEnabled = true
) {
  return useQuery({
    queryKey: [
      GET_ORGANIZATION_TEMPLATES_FILTERS_METADATA,
      { organizationId: organizationId },
    ],
    retry: 3,
    enabled: isEnabled && Boolean(organizationId),
    queryFn: async () => {
      const { data } = await getOrganizationTemplatesMetadata(organizationId);
      return data;
    },
    select,
  });
}
